<template>
  <div class="card-content">
    <div class="card-content-item">
      <div class="card-content-result">
        <strong><Skeleton width="20px" height="30px" /></strong>

        <!-- <PercentStatus :percent-value="-14"></PercentStatus> -->
      </div>
      <span><Skeleton width="100px" height="18px" /></span>
      <div class="hr">
        <Hr />
      </div>
      <div class="card-footer-item">
        <Skeleton width="24px" height="24px" borderRadius="7px" />
        <div>
          <span class="mb-5"><Skeleton width="85px" height="15px" /></span>
          <strong><Skeleton width="20px" height="15px" /></strong>
        </div>
      </div>
    </div>
    <div class="card-content-item">
      <div class="card-content-result">
        <strong><Skeleton width="20px" height="30px" /></strong>
        <!-- <PercentStatus :percent-value="2"></PercentStatus> -->
      </div>
      <span><Skeleton width="100px" height="18px" /></span>
      <div class="hr">
        <Hr />
      </div>
      <div class="card-footer-item">
        <Skeleton width="24px" height="24px" borderRadius="7px" />
        <div>
          <span class="mb-5"><Skeleton width="85px" height="15px" /></span>
          <strong><Skeleton width="20px" height="15px" /></strong>
        </div>
      </div>
    </div>
    <div class="card-content-item">
      <div class="card-content-result">
        <strong><Skeleton width="20px" height="30px" /></strong>
        <!-- <PercentStatus :percent-value="0"></PercentStatus> -->
      </div>
      <span><Skeleton width="100px" height="18px" /></span>
      <div class="hr">
        <Hr />
      </div>
      <div class="card-footer-item">
        <Skeleton width="24px" height="24px" borderRadius="7px" />
        <div>
          <span class="mb-5"><Skeleton width="85px" height="15px" /></span>
          <strong><Skeleton width="20px" height="15px" /></strong>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Skeleton from '@/components/Skeleton/Skeleton';
import { Hr } from '@n11/so-ui-components';

export default {
  name: 'QuickAccessSkeleton',
  components: {
    Skeleton,
    Hr,
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
@import '@/assets/styles/mobiles.scss';
@import '@/assets/styles/mobilesFooter.scss';
@import '@/assets/styles/card.scss';

.hr {
  width: 90%;
  margin: 10px 0;
}
span {
  display: block;
}
strong {
  display: block;
}
</style>
